export const CLONE_AND_EDIT = 'benefitsPage/CLONE_AND_EDIT';

export const REMOVE = 'benefitsPage/REMOVE';
